import { render, staticRenderFns } from "./left1.vue?vue&type=template&id=2129cc8c&"
import script from "./left1.vue?vue&type=script&lang=js&"
export * from "./left1.vue?vue&type=script&lang=js&"
import style0 from "./left1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports